module.exports = __webpack_public_path__ + "img/logo-geon-horizontal.e6854136.svg";